import { Injectable } from "@angular/core";
import { ApiService } from "../data/services/api.service";
import { apiColletions } from "../core/constant/api-collection";
import { BehaviorSubject, Observable } from "rxjs";
import { Helper } from "./helper";
import { AdminSettingsService } from "./admin-settings.service";
import { UserService } from "../data/services/user.service";

@Injectable({ providedIn: 'root' })

export class AuthService {

  public logginUserToken: any;
  public loginSubject = new BehaviorSubject<any>(null);
  loginObservable: Observable<any> = this.loginSubject.asObservable();
  private permissions = new BehaviorSubject<any>(null);
  authPermission = this.permissions.asObservable();
  isMainAdminLogin: boolean = true;

  get isAuthenticated(): boolean {
    return !this.logginUserToken || this.logginUserToken === null;
  }

  constructor(private _api: ApiService, private helper: Helper, private userService: UserService,private adminService: AdminSettingsService) { }

  login(parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      this._api.post({ url: apiColletions.login, parameters }).subscribe({
        next: (response: any) => {
          if (response.token) {
            this.logginUserToken = response.token;
            this.helper.isMainAdmin = true;
            this.isMainAdminLogin = true;
            this.helper.userToken = this.logginUserToken;
            localStorage.setItem("userToken", this.logginUserToken);
            this.loginSubject.next(this.logginUserToken);
            this.autologin();
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(response.data);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  autologin(): Promise<void> {
    return new Promise<any>((resolve) => {
      if (localStorage.getItem("userToken")) {
        this.logginUserToken = localStorage.getItem("userToken");
      }
      if (this.logginUserToken) {
        this.handleLoggedInUser().then(() => resolve(true));
      } else if (!this.logginUserToken) {
        this.logginUserToken = null;
        this.loginSubject.next(this.logginUserToken);
        localStorage.removeItem("userToken");
        // this.helper._route.navigate(["/"]);
        resolve(true);
      }
    });
  }

  handleLoggedInUser(): Promise<any> {
    return new Promise((resolve) => {
      const parameters: any = { isShowSuccessToast: false, isShowErrorToast: false };
      this.userService.getUserDetail(parameters).subscribe({
        next: () => resolve(true), // Resolve after successfully fetching user details
        error: () => resolve(false), // Resolve even if there's an error
      });
    });
  }

  register(parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      this._api.post({ url: apiColletions.register, parameters }).subscribe({
        next: (response: any) => {
          if (response.token) {
            this.logginUserToken = response.token;
            this.helper.userToken = this.logginUserToken;
            localStorage.setItem("userToken", this.logginUserToken);
            this.loginSubject.next(this.logginUserToken);
            this.autologin();
          }
          observer.next(response.data);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  sendOtp(parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      this._api.post({ url: apiColletions.sendOtp, parameters }).subscribe({
        next: (response: any) => {
          observer.next(response.data);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  verifyOtp(parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      this._api.post({ url: apiColletions.verifyOtp, parameters }).subscribe({
        next: (response: any) => {
          if (response.token) {
            this.logginUserToken = response.token;
            this.helper.userToken = this.logginUserToken;
            localStorage.setItem("userToken", this.logginUserToken);
            this.loginSubject.next(this.logginUserToken);
            this.autologin();
          }
          observer.next(response.data);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  forgotPassword(parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      this._api.post({ url: apiColletions.forgotPassword, parameters }).subscribe({
        next: (response: any) => {
          observer.next(response.data);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
